import { Button, Dialog, DialogActions, DialogContent, DialogTitle, styled } from '@mui/material';
import PasswordField from 'shared/Pages/common/Login/components/password-field';
import { FormikContextType } from 'formik';

export const ConfirmPasswordFormStyled = styled('form', { name: 'ConfirmPasswordFormStyled' })({
	display: 'flex',
	flexDirection: 'column',
	gap: 1.5,
});

type SettingsConfirmPasswordDialogProps = {
	toggleOpen: () => void;
	formik: FormikContextType<{ passwordConfirm: string; password: string }>;
};

export default function SettingsConfirmPasswordDialog(props: SettingsConfirmPasswordDialogProps) {
	const { toggleOpen, formik } = props;

	return (
		<Dialog open onClose={toggleOpen} fullWidth maxWidth="xs">
			<DialogTitle variant="h3">Change password</DialogTitle>
			<DialogContent>
				<ConfirmPasswordFormStyled onSubmit={formik.handleSubmit}>
					<PasswordField
						disabled={formik.isSubmitting}
						formik={formik}
						label="Password"
						name="password"
						placeholder="Create a strong password"
					/>
					<PasswordField
						disabled={formik.isSubmitting}
						formik={formik}
						label="Confirm password"
						name="passwordConfirm"
						placeholder="Confirm new password"
					/>
				</ConfirmPasswordFormStyled>
			</DialogContent>
			<DialogActions>
				<Button type="submit" disabled={!formik.dirty || formik.isSubmitting || !formik.isValid}>
					Set new password
				</Button>
			</DialogActions>
		</Dialog>
	);
}
